import React, { useState } from 'react';
import { useShift } from '../../context/ShiftContext';
import { useUser } from '../../context/UserContext';
import { format, parseISO, addMonths, startOfMonth, endOfMonth, eachDayOfInterval, isWeekend } from 'date-fns';
import { PlusIcon, XIcon } from 'lucide-react';
const ManageAssignments = () => {
  const {
    shifts,
    holidays,
    assignUserToShift,
    removeUserFromShift
  } = useShift();
  const {
    users
  } = useUser();
  const [startDate, setStartDate] = useState(new Date());
  const [successMessage, setSuccessMessage] = useState('');
  // Get days for next three months
  const firstDay = startOfMonth(startDate);
  const lastDay = endOfMonth(addMonths(startDate, 2));
  const days = eachDayOfInterval({
    start: firstDay,
    end: lastDay
  });
  const handleAssignUser = (shiftId: number, userId: number) => {
    assignUserToShift(shiftId, userId);
    setSuccessMessage('APN assigned successfully!');
    setTimeout(() => {
      setSuccessMessage('');
    }, 3000);
  };
  const handleRemoveUser = (shiftId: number, userId: number) => {
    if (window.confirm('Are you sure you want to remove this assignment?')) {
      removeUserFromShift(shiftId, userId);
      setSuccessMessage('Assignment removed successfully!');
      setTimeout(() => {
        setSuccessMessage('');
      }, 3000);
    }
  };
  return <div data-id="element-151">
      <h3 className="text-xl font-semibold mb-6 text-gray-700" data-id="element-152">
        Manage Assignments
      </h3>
      <p className="text-gray-600 mb-4" data-id="element-153">
        Manually assign APNs to shifts. Weekend shifts can have up to 2 APNs,
        while night and holiday shifts can have 1 APN.
      </p>
      {successMessage && <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded mb-4" data-id="element-154">
          {successMessage}
        </div>}
      <div className="overflow-x-auto" data-id="element-155">
        <table className="min-w-full divide-y divide-gray-200" data-id="element-156">
          <thead data-id="element-157">
            <tr data-id="element-158">
              <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-159">
                Date
              </th>
              <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-160">
                Day
              </th>
              <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-161">
                Holiday
              </th>
              <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-162">
                Night Shift
              </th>
              <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-163">
                Weekend Shifts
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200" data-id="element-164">
            {days.map(day => {
            const dateString = format(day, 'yyyy-MM-dd');
            const holiday = holidays.find(h => h.date === dateString);
            const nightShift = shifts.find(s => s.date === dateString && s.type === 'night');
            const weekendShift = shifts.find(s => s.date === dateString && s.type === 'weekend');
            const holidayShift = shifts.find(s => s.date === dateString && s.type === 'holiday');
            const isWeekendDay = isWeekend(day);
            return <tr key={dateString} className={`${isWeekendDay ? 'bg-gray-50' : ''} ${holiday ? 'bg-red-50' : ''}`} data-id="element-165">
                  <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-166">
                    {format(day, 'MM/dd/yyyy')}
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500" data-id="element-167">
                    {format(day, 'EEEE')}
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-500" data-id="element-168">
                    {holiday?.name || ''}
                    {holiday && holidayShift && <div className="mt-2 space-y-2" data-id="element-169">
                        {holidayShift.assignedTo.map(userId => {
                    const user = users.find(u => u.id === userId);
                    return <div key={userId} className="flex items-center justify-between bg-blue-50 px-2 py-1 rounded" data-id="element-170">
                              <span className="text-xs" data-id="element-171">{user?.name}</span>
                              <button onClick={() => handleRemoveUser(holidayShift.id, userId)} className="text-red-600 hover:text-red-800" data-id="element-172">
                                <XIcon size={14} data-id="element-173" />
                              </button>
                            </div>;
                  })}
                        {holidayShift.assignedTo.length < 1 && <select onChange={e => {
                    if (e.target.value) {
                      handleAssignUser(holidayShift.id, parseInt(e.target.value));
                      e.target.value = '';
                    }
                  }} className="text-xs border border-gray-300 rounded px-2 py-1 w-full" data-id="element-174">
                            <option value="" data-id="element-175">Assign APN...</option>
                            {users.map(user => <option key={user.id} value={user.id} data-id="element-176">
                                {user.name}
                              </option>)}
                          </select>}
                      </div>}
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-500" data-id="element-177">
                    {nightShift && <div className="space-y-2" data-id="element-178">
                        {nightShift.assignedTo.map(userId => {
                    const user = users.find(u => u.id === userId);
                    return <div key={userId} className="flex items-center justify-between bg-blue-50 px-2 py-1 rounded" data-id="element-179">
                              <span className="text-xs" data-id="element-180">{user?.name}</span>
                              <button onClick={() => handleRemoveUser(nightShift.id, userId)} className="text-red-600 hover:text-red-800" data-id="element-181">
                                <XIcon size={14} data-id="element-182" />
                              </button>
                            </div>;
                  })}
                        {nightShift.assignedTo.length < 1 && <select onChange={e => {
                    if (e.target.value) {
                      handleAssignUser(nightShift.id, parseInt(e.target.value));
                      e.target.value = '';
                    }
                  }} className="text-xs border border-gray-300 rounded px-2 py-1 w-full" data-id="element-183">
                            <option value="" data-id="element-184">Assign APN...</option>
                            {users.map(user => <option key={user.id} value={user.id} data-id="element-185">
                                {user.name}
                              </option>)}
                          </select>}
                      </div>}
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-500" data-id="element-186">
                    {isWeekendDay && weekendShift && <div className="space-y-2" data-id="element-187">
                        {weekendShift.assignedTo.map(userId => {
                    const user = users.find(u => u.id === userId);
                    return <div key={userId} className="flex items-center justify-between bg-purple-50 px-2 py-1 rounded" data-id="element-188">
                              <span className="text-xs" data-id="element-189">{user?.name}</span>
                              <button onClick={() => handleRemoveUser(weekendShift.id, userId)} className="text-red-600 hover:text-red-800" data-id="element-190">
                                <XIcon size={14} data-id="element-191" />
                              </button>
                            </div>;
                  })}
                        {weekendShift.assignedTo.length < 2 && <select onChange={e => {
                    if (e.target.value) {
                      handleAssignUser(weekendShift.id, parseInt(e.target.value));
                      e.target.value = '';
                    }
                  }} className="text-xs border border-gray-300 rounded px-2 py-1 w-full" data-id="element-192">
                            <option value="" data-id="element-193">
                              Assign APN {weekendShift.assignedTo.length + 1}...
                            </option>
                            {users.filter(u => !weekendShift.assignedTo.includes(u.id)).map(user => <option key={user.id} value={user.id} data-id="element-194">
                                  {user.name}
                                </option>)}
                          </select>}
                      </div>}
                  </td>
                </tr>;
          })}
          </tbody>
        </table>
      </div>
    </div>;
};
export default ManageAssignments;